import React from "react";
import "./organization-settings-events-list.scss";

import {
  GSSidePanelPage,
  GSItemList,
  GSActionBar,
} from "golfstatus_react_components";
import {
  faChevronLeft,
  faExternalLinkSquareAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getSettingsEventsPages } from "../../forms/SettingsForm";
import NavigationListItem from "../navigation-list-item";
import { useSelector } from "react-redux";
import { selectCurrentOrganization } from "../../reducers/organizationSlice";

const OrganizationSettingsEventsList = (props) => {
  const navigate = useNavigate();
  const selectedOrganization = useSelector(selectCurrentOrganization);

  const navigationSelected = (page) => {
    navigate(page.url);
  };

  const getItemList = () => {
    return (
      <GSItemList
        items={getSettingsEventsPages()}
        listItem={(page) => <NavigationListItem page={page} />}
        type="vertical selectable"
        itemSelected={navigationSelected}
      ></GSItemList>
    );
  };
  const goToEventsList = () => {
    window.open(
      `${process.env.REACT_APP_GOLFSTATUS_EVENTS_BASE_URL}/organization/${selectedOrganization.id}`
    );
  };

  const getActions = () => {
    return [
      {
        title: "View Events List",
        actionClick: goToEventsList,
        rightIcon: faExternalLinkSquareAlt,
        type: "light-grey no-wrap mobile-icon",
      },
    ];
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: "Events List",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };
  const getContent = () => {
    return (
      <gs-form>
        <GSActionBar
          type="form-header"
          header="Events List"
          pageActions={getActions()}
        />
        {getItemList()}
      </gs-form>
    );
  };

  return (
    <organization-settings-events-list>
      <GSSidePanelPage header={getNavigation()} content={getContent()} />
    </organization-settings-events-list>
  );
};

export default OrganizationSettingsEventsList;
